<template>
  <div class='modal-container'>
    <div class='modal-header fl error'>
      <h3>{{ modalData.title }}</h3>
    </div>

    <div class='modal-body hf'>
      <p>{{ modalData.text }}</p>
    </div>

    <div class='modal-footer'>
      <Button gray @click="this.handleClose" style="float: right;">{{ 'buttons.close' | translate }}</Button>
      <div style='clear: both;' />
    </div>
  </div>
</template>

<script>
import Button from '@aevitae/aevitaeui/0_atoms/buttons/Button.vue';
import Modal from '@/shared/constants/modal';

export default {
  name: 'Error',
  components: {
    Button
  },
  props: {
    modalData: null
  },
  methods: {
    handleClose () {
      this.$store.dispatch(Modal.Actions.CLOSE);
    }
  }
};
</script>
